import { FunctionComponent, useEffect, useState } from 'react';
import TopMenu from '../shared/top-menu/top-menu';
import Footer from '../shared/footer/footer';
import './news.scss';

import NewsTopBanner from './news-top-banner';
import NewsPSImagoPro10 from './posts/ps-imago-pro-10';
import NewsBox from './news-box';
import NewsPSImagoPro9 from './posts/ps-imago-pro-9';
import BuyNowButton from '../shared/buy-now-button/buy-now-button';
import DIV from '../shared/html-tags/div';
import { Helmet } from 'react-helmet-async';
export type Props = {};

const News: FunctionComponent<Props> = (props) => {
  const [newsPost, setNewsPost] = useState<string | undefined>(undefined);
  const [newsPostTitle, setNewsPostTitle] = useState<string | undefined>(undefined);

  useEffect(() => {
    const path = window.location.pathname;
    const parts = path.split('/');
    if (parts.length > 3) {
      setNewsPost(parts[3]);
    }
  }, []);

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>News - PS IMAGO PRO</title>
        <meta
          name="description"
          content="Bleibe auf dem Laufenden mit den neuesten Nachrichten und Updates zu PS IMAGO PRO, der führenden Analyse- und Reporting-Lösung von Predictive Solutions."
        />
        <meta
          name="keywords"
          content="PS IMAGO PRO, News, Updates, Predictive Solutions, Analyse, Reporting"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/news" />
      </Helmet>
      <div className="page news">
        <TopMenu selected="news"></TopMenu>
        <NewsTopBanner newsPostTitle={newsPostTitle} />

        {!newsPost && (
          <div className="page-content bg-1">
            <div className="inner-content">
              <DIV language="de" className="news-boxes">
                <NewsBox
                  title="PS IMAGO PRO 10 /// WHAT'S NEW"
                  creationDate={'14.03.2024'}
                  description="Die neue Version von PS IMAGO PRO – der führenden Analyse- und Reporting-Lösung von Predictive Solutions – ist jetzt verfügbar!"
                  link="/de/news/ps-imago-pro-10"
                />
                <NewsBox
                  title="PS IMAGO PRO 9 /// WHAT'S NEW"
                  creationDate={'30.12.2022'}
                  description="Die neue Version von PS IMAGO PRO – der führenden Analyse- und Reporting-Lösung von Predictive Solutions – ist jetzt verfügbar!"
                  link="/de/news/ps-imago-pro-9"
                />
              </DIV>

              <DIV language="en" className="news-boxes">
                <NewsBox
                  title="PS IMAGO PRO 10 /// WHAT'S NEW"
                  creationDate={'14.03.2024'}
                  description="The new version of PS IMAGO PRO – Predictive Solutions' flagship analysis and reporting solution – is now available!"
                  link="/en/news/ps-imago-pro-10"
                />
                <NewsBox
                  title="PS IMAGO PRO 9 /// WHAT'S NEW"
                  creationDate={'30.12.2022'}
                  description="The new version of PS IMAGO PRO – Predictive Solutions' flagship analysis and reporting solution – is now available!"
                  link="/en/news/ps-imago-pro-9"
                />
              </DIV>
            </div>
          </div>
        )}

        <div className="page-content bg-1">
          <div className="inner-content">
            <NewsPSImagoPro10 postLink={newsPost} setNewsPostTitle={setNewsPostTitle} />
            <NewsPSImagoPro9 postLink={newsPost} setNewsPostTitle={setNewsPostTitle} />
            <div style={{ textAlign: 'center', margin: '4rem 0' }} className="news-post-bottom-btn">
              <BuyNowButton order="buy" />
              {newsPost && (
                <>
                  <a href="/de/news" className="buy-now-button">
                    Zurück zur Übersicht
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </>
  );
};

export default News;
